import { ClickableCard } from '@azelis/ui/components/clickableCard';
import { Link } from '@tanstack/react-router';
import { paths } from '@/routes/paths';

export default function Home() {
  return (
    <div className="flex w-full flex-col items-center gap-[82px] text-center">
      <h1 className="max-w-3xl text-4xl leading-10 font-semibold text-foreground">
        Welcome to the Questionnaire Assistant
      </h1>
      <div className="flex w-full flex-col items-center gap-[90px]">
        <p className="text-xl leading-7 font-semibold text-foreground">
          How do you want to start?
        </p>
        <div className="grid w-full max-w-[1213px] grid-cols-1 items-stretch gap-8 md:grid-cols-3">
          <ClickableCard
            render={
              <Link
                to={paths.submit}
                search={{ mode: 'file' }}
              />
            }
            title="Upload questionnaire"
            description="Upload a questionnaire that needs to be processed by AI"
          />
          <ClickableCard
            render={
              <Link
                to={paths.submit}
                search={{ mode: 'questions' }}
              />
            }
            title="Upload questions"
            description="Upload questions that need to be processed by AI"
          />
          <ClickableCard
            render={<Link to={paths.overview} />}
            title="Upload overview"
            description="Overview of your uploaded questionnaires"
          />
        </div>
      </div>
    </div>
  );
}
